
import { propsInstance } from "@/lib/util";
import { Component, MixedVue } from "@/vue";
import { mixins } from "vue-class-component";

const Props = propsInstance<{ name: string }>({
  name: {
    type: String,
    required: true,
  },
});

@Component({
  name: "FeatureFlag",
})
export default class FeatureFlag extends mixins(MixedVue, Props) {
  get flagActive() {
    return this.$store.getters.featureFlags[this.name]?.active;
  }
}
